export class ValueDistributor {
  constructor(
    private readonly _totalAvailable: number,
    private readonly _numberOfCandidates: number
  ) {}

  public distribute(): Array<number> {
    const initialDistributionAmount = Math.floor(
      this._totalAvailable / this._numberOfCandidates
    );
    const distribution: Array<number> = new Array(
      this._numberOfCandidates
    ).fill(initialDistributionAmount);

    let remainingAmount =
      this._totalAvailable -
      initialDistributionAmount * this._numberOfCandidates;
    let index = 0;

    while (remainingAmount > 0) {
      distribution[index] += 1;
      index++;
      remainingAmount--;
    }

    return distribution;
  }
}
